import type React from "react";

interface ProgressBarProps {
	value: number;
	tone?: "primary" | "green";
	className?: string;
}

const normalize = (value: number): number => {
	if (Number.isNaN(value) || !Number.isFinite(value)) return 0;
	return Math.max(0, Math.min(100, Math.round(value)));
};

const ProgressBar: React.FC<ProgressBarProps> = ({ value, tone = "primary", className = "" }) => {
	const normalizedValue = normalize(value);
	const toneClass = tone === "green" ? "progress-fill-green" : "";

	return (
		<div className={`progress-fill ${toneClass} ${className}`.trim()}>
			<progress max={100} value={normalizedValue} />
		</div>
	);
};

export default ProgressBar;
